import React from 'react';
import { PRIORITIES, LABELS, COLUMNS } from './taskData';

function TaskModal({ task, onClose, onEdit, onDelete, onToggleSubtask }) {
  const priority = PRIORITIES[task.priority];
  const taskLabels = LABELS.filter((l) => task.labels.includes(l.id));
  const column = COLUMNS[task.column];
  const subtasksDone = task.subtasks.filter((s) => s.done).length;
  const subtasksTotal = task.subtasks.length;
  const createdDate = new Date(task.createdAt).toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric',
  });

  return (
    <div className="tm-modal-overlay" onClick={onClose}>
      <div className="tm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="tm-modal-header">
          <div className="tm-modal-status">
            <span className="tm-modal-column-badge">
              {column.icon} {column.title}
            </span>
            <span className="tm-modal-priority" style={{ color: priority.color }}>
              {priority.icon} {priority.label}
            </span>
          </div>
          <div className="tm-modal-actions">
            <button className="tm-modal-action-btn" onClick={() => onEdit(task)} title="Edit">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
                <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
            </button>
            <button className="tm-modal-action-btn delete" onClick={() => onDelete(task.id)} title="Delete">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="3 6 5 6 21 6" />
                <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
              </svg>
            </button>
            <button className="tm-modal-action-btn" onClick={onClose} title="Close">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>
        </div>

        <h2 className="tm-modal-title">{task.title}</h2>

        <div className="tm-modal-labels">
          {taskLabels.map((label) => (
            <span
              key={label.id}
              className="tm-modal-label"
              style={{ background: label.color + '22', color: label.color }}
            >
              {label.name}
            </span>
          ))}
        </div>

        <div className="tm-modal-section">
          <h3 className="tm-modal-section-title">Description</h3>
          <p className="tm-modal-description">{task.description || 'No description provided.'}</p>
        </div>

        {subtasksTotal > 0 && (
          <div className="tm-modal-section">
            <div className="tm-modal-subtasks-header">
              <h3 className="tm-modal-section-title">Subtasks</h3>
              <span className="tm-modal-subtask-count">{subtasksDone}/{subtasksTotal}</span>
            </div>
            <div className="tm-modal-subtask-progress">
              <div
                className="tm-modal-subtask-progress-fill"
                style={{ width: `${(subtasksDone / subtasksTotal) * 100}%` }}
              ></div>
            </div>
            <ul className="tm-modal-subtasks">
              {task.subtasks.map((sub) => (
                <li
                  key={sub.id}
                  className={`tm-modal-subtask ${sub.done ? 'done' : ''}`}
                  onClick={() => onToggleSubtask(task.id, sub.id)}
                >
                  <span className="tm-subtask-check">
                    {sub.done ? (
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="var(--accent)" stroke="var(--accent)" strokeWidth="2">
                        <rect x="3" y="3" width="18" height="18" rx="3" />
                        <polyline points="9 12 12 15 16 9" stroke="#fff" strokeWidth="2.5" />
                      </svg>
                    ) : (
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--text-secondary)" strokeWidth="2">
                        <rect x="3" y="3" width="18" height="18" rx="3" />
                      </svg>
                    )}
                  </span>
                  <span className="tm-subtask-text">{sub.text}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="tm-modal-footer">
          <span className="tm-modal-date">Created {createdDate}</span>
        </div>
      </div>
    </div>
  );
}

export default TaskModal;
